(function($, undefined) {
	
	'use strict';
	
	
	var init = function () {
		$('a[href]').each(function() {
			var url = $(this).attr('href');
			var hasQuest = false;
			var hasAmp = false;
			
			if(url.indexOf('?') != -1) {
			    hasQuest = true;
			}
			if(url.indexOf('&') != -1) {
			    hasAmp = true;
			}
			
			if (hasAmp && !hasQuest) {
//				console.log('after : ' + url.substr(0, url.indexOf('&')) + '?' + url.substr(url.indexOf('&') + 1));
				$(this).attr('href', url.substr(0, url.indexOf('&')) + '?' + url.substr(url.indexOf('&') + 1));
			}
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
